define('../src/sublayouts/m25-photo-gallery/m25-photo-gallery',['jquery', 'slick'], function ($) {

	'use strict';

	var M25_PHOTO_GALLERY = function ($component) {

		this.$component = $component;

		return this;
	};

	/**
	 * Initialise component
	 */

	 M25_PHOTO_GALLERY.prototype.init = function () {
		var _this = this;
		this.$mainSlider = this.$component.find('.m25-photo-gallery__main-carousel');
		this.$navSlidesToShow = 6;
		this.$gutter = ($( window).width() >= 1024) ? 32 : 16;
		this.$padding = ($( window).width() >= 1024) ? 0 : 32;
		this.$body = $('body');
		this.$html = $('html');
		this.$isRTL = (this.$html.attr('dir') == 'rtl');
		this.shareOpen = false;
		var photoList = this.$component.find('.m24-photo-gallery--list'),
		$item = photoList.find('.m24-photo-gallery--list-item'),
		modalTrigger = this.$component.find('.m18-modal__trigger');

		_this.getData();
		$item.on('click',function(){
			
			if(_this.$mainSlider.hasClass('slick-slider')){
				_this.$mainSlider.empty()
				_this.$mainSlider.removeClass('slick-initialized')
				_this.$mainSlider.removeClass('slick-slider')
			}
			_this.getData();
			_this.$mainSlider.slick('goTo', $(this).data('index'))
			modalTrigger.trigger('click')
			_this.$mainSlider.focus()

			$(document).on('keydown', function(e) {
				if($('.m18-modal--photo-gallery .m18-modal__container').hasClass('m18-modal__container--active')){
					if(e.keyCode == 37) {
						_this.$mainSlider.slick('slickPrev');
					}
					if(e.keyCode == 39) {
						_this.$mainSlider.slick('slickNext');
					}
				}
            });
		})
		$(window).on('m25.init',function(){
			_this.init()
		})
		

	};

	M25_PHOTO_GALLERY.prototype.getData = function(){
		var _this = this,
			photoList = this.$component.find('.m24-photo-gallery--list'),
			$item = photoList.find('.m24-photo-gallery--list-item'),
			itemsArr = [];

			$item.each(function(){
				var obj = {
					"url" : $(this).data('url'),
					"caption" : $(this).data('caption')
				}
				itemsArr.push(obj)
			})
			_this.buildGallery(itemsArr)
	}

	M25_PHOTO_GALLERY.prototype.buildGallery = function(data){
			var _this = this,
				gallerywrapper = this.$component.find('.m25-photo-gallery__main-carousel'),
				i = 0;

			$.each(data,function(){
				gallerywrapper.append('<div class="m25-photo-gallery__main-carousel-slide" data-index="'+ i +'" data-caption="'+this.caption+'"> <div class="m25-photo-gallery__main-carousel-slide-inner"> <img class="m25-photo-gallery__main-carousel-slide-image" src="'+this.url+'" alt="'+this.caption+'" /> </div></div>')
				i++
			})
			_this.initMainCarousel()
	}
	


	M25_PHOTO_GALLERY.prototype.initMainCarousel = function () {
		var _ = this;

		this.$mainSlider.slick({
			arrows: true,
			dots: false,
			infinite: true,
			speed: 750,
			fade:true,
			rtl: $('html').attr('dir') == 'rtl' ? true : false,
			autoplay: false,
			adaptiveHeight: true
		});
	};



	return M25_PHOTO_GALLERY;
});

